import { Spacing, Text, Title } from '@vkontakte/vkui';
import coverImage from 'img/welcome/welcomeDialogCoverKaspersky.jpg';
import React, { memo, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

import styles from './WelcomeDialogNew.css';

interface IProps {
    onSuccess: () => void;
    onShow: () => void;
}

export const WelcomeDialogNew = memo<IProps>(({ onSuccess, onShow }) => {
    const quota = useSelector(UserSelectors.getCloudSpace);

    useEffect(() => {
        onShow();
    }, []);

    const content = useMemo(() => {
        return (
            <div className={styles.content}>
                <Title level="3" className={styles.title} weight="medium">
                    Облако заботится о ваших файлах
                </Title>
                <Spacing size={12} />
                <Text className={styles.text}>
                    Делитесь фотографиями, видео и документами с друзьями. Это безопасно: все файлы в Почте и Облаке проверены антивирусом
                    Касперского и надёжно защищены
                </Text>
                <Spacing size={32} />
            </div>
        );
    }, [quota]);

    const footerText = useMemo(() => {
        return (
            <div className={styles.footerText}>
                Нажимая на кнопку, вы принимаете{' '}
                <a href="https://help.mail.ru/legal/terms/cloud/LA" target="_blank" rel="noreferrer">
                    Лицензионное соглашение
                </a>
                <br />и{' '}
                <a href="https://help.mail.ru/legal/terms/cloud/privacy" target="_blank" rel="noreferrer">
                    Политику конфиденциальности
                </a>
            </div>
        );
    }, []);

    return (
        <WhatsNewDialog
            closable={false}
            onClick={onSuccess}
            primaryButtonText="Хорошо"
            title=""
            content={content}
            imageUrl={coverImage}
            imageBgColor="#ffffff"
            footerText={footerText}
        />
    );
});

WelcomeDialogNew.displayName = 'WelcomeDialogNew';
